import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/layton-logo.svg';
import nineAndDineLogo from '../assets/nine-and-dine-logo.png';

const isAdminDomain = window.location.hostname === 'admin.laytonrsvp.com';

const navLinks = [
  { label: 'Tournament Info', path: '/', scroll: 'tournament-content' },
  { label: 'Events & RSVP', path: '/events' },
  { label: 'Recaps', path: '/recaps' },
  { label: 'Flyer', path: '/flyer' },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  const currentMonth = new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

  const handleNavClick = (item) => {
    navigate(item.path);
    if (item.scroll) {
      setTimeout(() => {
        const el = document.getElementById(item.scroll);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 150);
    }
  };

  return (
    <>
      <header className={`site-navbar ${scrolled ? 'navbar-scrolled' : 'navbar-transparent'}`}>
        <div className="navbar-inner">
          <div className="navbar-logo" onClick={() => navigate('/')} role="button" tabIndex={0} style={{ cursor: 'pointer' }}>
            <img src={nineAndDineLogo} alt="Layton Nine & Dine" className="navbar-logo-img navbar-nine-dine-logo" />
          </div>
          {!isAdminDomain && (
            <>
              <nav className="navbar-links">
                {navLinks.map((item) => (
                  <button
                    key={item.path}
                    className={`navbar-link ${isActive(item.path) ? 'navbar-link-active' : ''}`}
                    onClick={() => handleNavClick(item)}
                  >
                    {item.label}
                  </button>
                ))}
                <button className="navbar-cta" onClick={() => navigate('/events', { state: { autoOpenFirst: true } })}>Register Now</button>
              </nav>
              <button
                className={`hamburger ${menuOpen ? 'hamburger-open' : ''}`}
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Toggle menu"
              >
                <span /><span /><span />
              </button>
            </>
          )}
        </div>
        {menuOpen && !isAdminDomain && (
          <div className="mobile-menu">
            {navLinks.map((item) => (
              <button
                key={item.path}
                className={`mobile-link ${isActive(item.path) ? 'mobile-link-active' : ''}`}
                onClick={() => { handleNavClick(item); setMenuOpen(false); }}
              >
                {item.label}
              </button>
            ))}
            <button className="mobile-cta" onClick={() => { navigate('/events', { state: { autoOpenFirst: true } }); setMenuOpen(false); }}>Register Now</button>
          </div>
        )}
      </header>

      {!isAdminDomain && (
        <section className="hero">
          <div className="hero-overlay" />
<div className="hero-content animate-fade-up">
            <img src={logo} alt="Layton" className="hero-logo" />
            <h1 className="hero-title">Nine &amp; Dine<br />Tournament Series</h1>
            <p className="hero-subtitle">Supporting 5 For The Fight &nbsp;&middot;&nbsp; {currentMonth} &nbsp;&middot;&nbsp; Shotgun Start 3:00 PM</p>
            <div className="hero-actions">
              <button className="hero-btn-primary" onClick={() => navigate('/events', { state: { autoOpenFirst: true } })}>Register Now</button>
              <button className="hero-btn-secondary" onClick={() => handleNavClick(navLinks[0])}>Tournament Info</button>
            </div>
          </div>
          <div className="hero-scroll-hint">
            <span>Scroll</span>
            <div className="scroll-line" />
          </div>
        </section>
      )}
    </>
  );
};

export default Header;
